export function matomoTracker(isLandingPage=false)
{
  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="//matomo.unpen.eu/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '1']);

    //to distinguish between landing page and main page as a connected user.
    let url = window.location.pathname + window.location.search
    if (isLandingPage){
      url = window.location.pathname + "/landing_page/" + window.location.search
    }

    _paq.push(['setDocumentTitle', document.title]);
    _paq.push(['setCustomUrl', url]);

    // measure the time spent in the last visited page more accurately (0s without it)
    _paq.push(['enableHeartBeatTimer']);
    _paq.push(['trackPageView']);

    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);

    
    //add tracking of scrolling.
    if (isLandingPage){
      window.addEventListener('scroll', function() {
        // Throttle execution to every 500ms to prevent performance issues
        clearTimeout(window.scrollTimeout);
        window.scrollTimeout = setTimeout(trackScrollDepth, 500);
      });
    }

    //add tracking of clicks.
    document.addEventListener('click', function(e) {
    _paq.push(['trackEvent', 'Click', url, e.target.tagName]);
  });

  })();

}

export function matomoEvent(eventType, var1, var2)
{
  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackEvent', eventType, var1, var2]);
}



//track scrolling depth.
function trackScrollDepth() {
  var _paq = window._paq = window._paq || [];

  var lastTrackedScroll = 0;
  var scrollDiffThresholds = 10;

  var scrollTop = window.scrollY || document.documentElement.scrollTop;
  var docHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
  var winHeight = window.innerHeight;
  var scrollPercent = Math.round((scrollTop + winHeight) / docHeight * 100);

 
  if (Math.max(lastTrackedScroll, scrollPercent) - Math.min(lastTrackedScroll, scrollPercent) >= scrollDiffThresholds) {
    //If the user scrolled at least scrollDiffThresholds (top or bottom) since last push.
    lastTrackedScroll = scrollPercent
    _paq.push(['trackEvent', 'Scroll Depth', scrollPercent + '%', window.location.pathname]);
  }
}